import React from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";

// Styles
import { BreadcrumbContainer, StyledBreadcrumbs, BreadcrumbLink, BreadcrumbText, IconWrapper } from "../styles/MeGenBreadcrumbs";

// Types
export type BreadcrumbItem = {
  label: string;
  path?: string;
  icon?: React.ReactNode;
}

export type MeGenBreadcrumbsProps = {
  items: BreadcrumbItem[];
  onNavigate?: (path: string) => void;
}

// Component
const MeGenBreadcrumbs: React.FC<MeGenBreadcrumbsProps> = ({
  items,
  onNavigate,
}) => {
  const handleClick = (path?: string) => {
    if (path && onNavigate) {
      onNavigate(path);
    }
  };

  return (
    <BreadcrumbContainer id="megen-breadcrumbs-container">
      <StyledBreadcrumbs
        id="megen-breadcrumbs-nav"
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const icon = item.icon || (index === 0 ? <FolderOutlinedIcon sx={{ fontSize: 18 }} /> : null);

          if (isLast) {
            return (
              <BreadcrumbText id={`megen-breadcrumb-item-${index}`} key={index}>
                {icon && <IconWrapper id={`megen-breadcrumb-icon-${index}`}>{icon}</IconWrapper>}
                {item.label}
              </BreadcrumbText>
            );
          }

          return (
            <BreadcrumbLink
              id={`megen-breadcrumb-item-${index}`}
              key={index}
              onClick={() => handleClick(item.path)}
              component="button"
            >
              {icon && <IconWrapper id={`megen-breadcrumb-icon-${index}`}>{icon}</IconWrapper>}
              {item.label}
            </BreadcrumbLink>
          );
        })}
      </StyledBreadcrumbs>
    </BreadcrumbContainer>
  );
};

export default MeGenBreadcrumbs;
